import * as React from "react";
import {
    Datagrid,
    TextField,
    Show,
    SimpleShowLayout,
    ShowProps,
} from "react-admin";
import { ReferenceManyToManyField } from "ra-relationships";
import { makeStyles } from "@material-ui/core";

const UserShowTitle = ({ record }: any) => {
    return <span>View User: {record ? `${record.email}` : ""}</span>;
};

const deviceRowStyle = (record: any, index: any) => ({
    backgroundColor: index % 2 === 0 ? "white" : "white",
});

const useStyles = makeStyles({
    header: {
        fontWeight: "bold",
    },
});

export const UserShow = (props: ShowProps) => {
    const classes = useStyles();
    return (
        <Show {...props} title={<UserShowTitle />}>
            <SimpleShowLayout>
                <TextField source="id" />
                <TextField source="name" />
                <TextField source="email" />
                <TextField source="phoneNumber" />

                <ReferenceManyToManyField
                    source="id"
                    reference="devices"
                    through="junction_user_device"
                    using="userUid,deviceUid"
                >
                    <Datagrid rowStyle={deviceRowStyle} stickyHeader>
                        <TextField
                            source="friendlyName"
                            headerClassName={classes.header}
                        />
                        <TextField
                            source="address"
                            headerClassName={classes.header}
                        />
                        <TextField
                            source="city"
                            headerClassName={classes.header}
                        />
                    </Datagrid>
                </ReferenceManyToManyField>
            </SimpleShowLayout>
        </Show>
    );
};
